import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalComponent, NotificationsService } from '@geekbears/ngx-gb-ui-kit';

import {
  deleteUserFailureAction,
  deleteUserSuccessAction,
  uploadFileSuccessAction,
  UsersActions,
} from '@modules/company-manager/users/application';
import { deleteUserLoadingSelector } from '@modules/company-manager/users/application';

export interface UserModal {
  type:
    | 'deleteUser'
    | 'deleteUserSuccess'
    | 'updatedUserSuccess'
    | 'importFile';
  id?: string;
}
export class CsvData {
  public firstName: any;
  public lastName: any;
  public email: any;
  public jobTitle: any;
  public department: any;
}
@Component({
  selector: 'app-users-modals',
  templateUrl: './users-modals.modal.html',
  styleUrls: ['./users-modals.modal.scss'],
})
export class UsersModals extends ModalComponent implements OnInit, OnDestroy {
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  modalType: string = '';
  fileName: string = '';
  userId: string = '';
  usersToUpload: any[] = [];

  deleteUserLoading$: Observable<boolean | any>;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<UsersModals>,
    private store$: Store,
    private actions$: Actions,
    private notificationService: NotificationsService,
    private router: Router
  ) {
    super();
    if (data) {
      this.modalType = data.type;
      this.userId = data.id ? data.id : '';
    }
    this.deleteUserLoading$ = this.store$.select(deleteUserLoadingSelector);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit(): void {
    this.onFailureActions();
    this.actions$
      .pipe(
        ofType(uploadFileSuccessAction),
        filter((action) => {
          return !isNil(action);
        }),
        map((action) => {
          this.notificationService.success('File Successfully Loaded', {
            duration: 3000,
            icon: 'check-circle',
          });
          this.closeModal();
          return action;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
    this.onDeleteUserSuccess();
  }

  onDeleteUserSuccess() {
    this.actions$
      .pipe(
        ofType(deleteUserSuccessAction),
        filter((action) => {
          return !isNil(action);
        }),
        map((action) => {
          this.notificationService.success('User successfully deleted', {
            duration: 3000,
            icon: 'check-circle',
          });
          this.closeModal();
          this.router.navigateByUrl('dashboard/users');
          return action;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  closeModal() {
    this.dialogRef.close();
  }
  importFile(event: any) {
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;

      let xlsx = event.target.files[0];

      let fileReader = new FileReader();
      fileReader.readAsBinaryString(xlsx);
    }
  }

  deleteUser() {
    this.store$.dispatch(
      UsersActions.deleteUser({
        userId: this.userId,
      })
    );
  }

  uploadFile() {
    if (this.usersToUpload && this.usersToUpload.length > 0) {
      if (
        this.usersToUpload[0]?.firstName &&
        this.usersToUpload[0]?.lastName &&
        this.usersToUpload[0]?.email &&
        this.usersToUpload[0]?.jobTitle &&
        this.usersToUpload[0]?.department
      ) {
        this.store$.dispatch(
          UsersActions.uploadFile({
            file: this.usersToUpload,
          })
        );
      } else {
        this.notificationService.warning(
          'The file has not the correct format',
          {
            duration: 3000,
          }
        );
      }
    } else {
      this.notificationService.warning('The file is empty', {
        duration: 3000,
      });
    }
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(deleteUserFailureAction),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  uploadListener($event: any): void {
    let text = [];
    let files = $event.srcElement.files;
    this.fileName = $event.target.files[0].name;

    if (this.isValidCSVFile(files[0])) {
      let input = $event.target;
      let reader = new FileReader();
      reader.readAsText(input.files[0]);

      reader.onload = () => {
        let csvData: any = reader.result;
        let csvRecordsArray = csvData.split(/\r\n|\n/);

        let headersRow = this.getHeaderArray(csvRecordsArray);

        let records = this.getDataRecordsArrayFromCSVFile(
          csvRecordsArray,
          headersRow.length
        );

        this.usersToUpload = records;
      };
    } else {
      alert('Please import valid .csv file.');
      // this.fileReset();
    }
  }
  isValidCSVFile(file: any) {
    return file.name.endsWith('.csv');
  }
  getHeaderArray(csvRecordsArr: any) {
    let headers = csvRecordsArr[0].split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }
  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(',');

      if (curruntRecord.length == headerLength) {
        let csvRecord: CsvData = {
          email: '',
          lastName: '',
          firstName: '',
          jobTitle: '',
          department: '',
        };

        csvRecord.firstName = curruntRecord[0].trim();
        csvRecord.lastName = curruntRecord[1].trim();
        csvRecord.email = curruntRecord[2].trim();
        csvRecord.jobTitle = curruntRecord[3].trim();
        csvRecord.department = curruntRecord[4].trim();

        csvArr.push(csvRecord);
      }
    }
    return csvArr;
  }

  downloadFile() {
    let filename = 'importMembersFileCP';
    let csvData = this.ConvertToCSV(
      [],
      ['firstName', 'lastName', 'email', 'jobTitle', 'department']
    );

    let blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray: any, headerList: any) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }
}
